import { useState, createContext, useEffect } from "react";
import axios from "axios";
import { Searchbar } from "./Searchbar";
import { Error } from "./Error";
import { Weather } from "./Weather";
import { Movies } from "./Movies";
import Image from "react-bootstrap/Image";

export const LocationContext = createContext();

function App() {
  // initialize state for forecast data that's returned from backend
  const [weatherData, setWeatherData] = useState([]);
  // initialize state for movie data that's returned from tmdb api
  const [movieData, setMovieData] = useState([]);
  // initialize state for city name search query
  const [searchQuery, setSearchQuery] = useState("");
  // initialize state for current location that's fetched from LocationIQ API
  const [location, setLocation] = useState({});
  // initialize state for possible errors
  const [error, setError] = useState(undefined);

  // TODO: fix functions so state of location is set before fetchWeatherData
  const fetchWeatherData = async () => {
    try {
      // try to fetch forecast data from backend
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_API}/weather`,
        {
          params: {
            searchQuery: searchQuery,
            lon: location.lon,
            lat: location.lat,
          },
        }
      );
      // update state of weatherData with data fetched from response
      setWeatherData(res.data);
    } catch (error) {
      // if code above fails, set weatherData to empty array
      setWeatherData([]);
    }
  };

  const fetchMovieData = async () => {
    try {
      // try to fetch data from TMDB API
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_API}/movies`,
        {
          params: {
            searchQuery: searchQuery,
          },
        }
      );
      // update state with data from axios response
      setMovieData(res.data);
    } catch (error) {
      // update state with empty array
      setMovieData([]);
    }
  };

  const getLocation = async () => {
    const locationQuery = `https://us1.locationiq.com/v1/search.php?key=${process.env.REACT_APP_API_KEY}&q=${searchQuery}&format=json`;
    const API = locationQuery;
    try {
      // try to fetch data from LocationIQ API
      const res = await axios.get(API);
      // update state of location with data fetched from LocationIQ
      handleLocation(res.data[0]);
      // if an error is still saved in state, reset it to undefined
      error && setError(undefined);
      // fetch forecast data
      fetchMovieData();
      // fetchWeatherData();
    } catch (error) {
      // if above code fails, update state of error
      setError({
        status: error.response.status,
        msg: error.response.data.error,
      });
      // reset state of location with an empty object
      handleLocation({});
    }
  };

  const handleSearchQuery = (data) => {
    setSearchQuery(data);
  };

  const handleLocation = (data) => {
    setLocation(data);
  };

  // setting up functions that'll be accessible through useContext
  const locationContextValue = {
    handleSearchQuery,
    getLocation,
  };

  useEffect(() => {
    fetchWeatherData();
  }, [location]);

  return (
    <LocationContext.Provider value={locationContextValue}>
      <div className="container">
        <Searchbar searchQuery={searchQuery} />
        {location.place_id && (
          <>
            <h2>
              The city is {location.display_name} at {location.lat},{" "}
              {location.lon}
            </h2>
            <div className="map-grid">
              <Image
                src={`https://maps.locationiq.com/v3/staticmap?key=${process.env.REACT_APP_API_KEY}&center=${location.lat},${location.lon}&zoom=13`}
                alt={`map center on ${location.display_name}`}
                style={{ borderRadius: "0.75em", marginTop: "1rem" }}
                fluid
              ></Image>
              <Weather forecasts={weatherData} />
            </div>
            <Movies movies={movieData} />
          </>
        )}
        {error && <Error status={error.status} msg={error.msg} />}
      </div>
    </LocationContext.Provider>
  );
}

export default App;
